export default {
    subscriber: null,
    loading: true
}



// WEBPACK FOOTER //
// ./src/modules/b2c_integration/state.js